export const common = {
  en: {
    Create: 'Create',
    Update: 'Update',
    Save: 'Save',
    Close: 'Close',
    'Are you sure?': 'Are you sure?',
    'Scroll down': 'Scroll down',
    'Scroll up': 'Scroll up',
    Actions: 'Actions',
    'Rows Per Page': 'Rows Per Page',
    Of: 'Of',
    Previous: 'Previous',
    Next: 'Next',
    "Can't be blank": "Can't be blank",
    Yes: 'Yes',
    No: 'No',
    'No Info': 'No Info',
    'Additional Filters': 'Additional Filters',
    Filter: 'Filter',
    'Filters have been changed but not applied':
      'Filters have been changed but not applied',
    'Loading...': 'Loading...',
    'Nothing Found': 'Nothing Found',
    'No Data Provided': 'No Data Provided',
    'No options available': 'No options available',
    Cash: 'Cash',
    cash: 'Cash',
    Card: 'Card',
    Terminal: 'Terminal',
    'Send to Terminal': 'Send to Terminal',
    'Terminal Payment': 'Terminal Payment',
    'Waiting for terminal...': 'Waiting for terminal...',
    'Sending to terminal': 'Sending to terminal',
    'Terminal accepted request': 'Terminal found',
    'Amount accepted by terminal': 'Amount displayed on terminal',
    'Payment successful': 'Payment successful',
    'Payment declined': 'Payment declined',
    'Waiting for payment': 'Waiting for payment',
    'Terminal not found': 'Terminal not found',
    'Terminal connection lost': 'Terminal connection lost',
    'Failed to send to terminal': 'Failed to send to terminal',
    Online: 'Online',
    'Transfer to card': 'Transfer to card',
    Deposit: 'Deposit',
    'Export CSV': 'Export CSV',
    'No services selected': 'No services selected',
    From: 'From',
    Till: 'Till (Not Including)',
    Confirmation: 'Confirmation',
    Confirm: 'Confirm',
    'Select File': 'Select File',
    'Choose File': 'Choose File',
    'Remove File': 'Remove File',
    'Are You Sure?': 'Are You Sure?',
    'Selected services': 'Selected services',
    'Show Hidden Services': 'Show Hidden Services',
    'Select services': 'Select services',
    'Choose services for the certificate':
      'Choose services for the certificate',
    'Choose services for the online service':
      'Choose services for the online service',
    Select: 'Select',
    Analytics: 'Analytics',
    'Edit Company': 'Edit Company',
    'Active Purchased services': 'Active purchased services by date',
    'Booking Analytics': 'Booking Analytics',
    Price: 'Price',
    Service: 'Service',
    Discount: 'Discount',
    Active: 'Active',
    UAH: 'UAH',
    fileWeightMsg: 'File must be smaller than {{size}} MB',
    'Paid Bookings By Booking Dates': 'Paid Bookings By Booking Dates',
    'Paid Bookings By Payment Dates': 'Paid Bookings By Payment Dates',
    Date: 'Date',
    Count: 'Count',
    Responses: 'Responses',
    'Select Location': 'Select Location',
    'Distributed money': 'Distributed money',
    'Money is distributed incorrectly': 'Money is distributed incorrectly',
    'Select payment type': 'Select payment type',
    ', left': ', left',
    'Select a payment card': 'Select a payment card',
    'Not enough deposit': 'Not enough deposit',
    'To basic payment types': 'To basic payment types',
    Total: 'Total',
    'Income Sources': 'Income sources',
    ufo_tooltip:
      'Unrecognized for online (UFO)\nOnline service purchase available\nacross multiple locations',
    'Client deposit': 'Client deposit',
    'Deposit movements': 'Deposit movements',
    'History of client deposit changes': 'History of client deposit changes',
    'Cancel order': 'Cancel order',
    'Cancel online order': 'Cancel online order',
    'Cancel order to deposit': 'Cancel order to deposit',
    'Cancel service usage': 'Cancel service usage',
    'Created At': 'Created At',
    Amount: 'Amount',
    in: 'In',
    out: 'Out',
    'to deposit': 'To deposit',
    'to client': 'To client',
    'Order ID': 'Order ID',
    'Order type': 'Order type',
    'Orders Info': 'Orders Info',
    'Payment type': 'Payment type',
    Fiscalized: 'Fiscalized',
    'Purchased Service Id': 'Purchased Service Id',
    User: 'User',
    Client: 'Client',
    Time: 'Time',
    'Action Type': 'Action Type',
    'Service Usage History Id': 'Service Usage History Id',
    'Payment Id': 'Payment Id',
    'User Activity Logs': 'User Activity Logs',
    Locations: 'Locations',
    'Service Usage History': 'Service Usage History',
    'Use Time': 'Use Time',
    'Service Id': 'Service Id',
    Trainer: 'Trainer',
    'Certificate Code': 'Certificate Code',
    'Final Price': 'Final Price',
    'Price per payment type': 'Price per payment type',
    Cancel: 'Cancel',
    'Send back to': 'Send back to',
    'Purchase of a certificate': 'Purchase of a certificate',
    'Purchase from the administrator': 'Purchase from the administrator',
    'Online booking': 'Online booking',
    Name: 'Name',
    'Display name': 'Display name',
    'System Owners': 'System Owners',
    Description: 'Description',
    Image: 'Image',
    'Choose Image File': 'Choose Image File',
    Promotion: 'Promotion',
    'Edit Promotion': 'Edit Promotion',
    'Update Promotion': 'Update Promotion',
    'Connect scanning device form': 'Connect scanning device form',
    'Wi-Fi name': 'Wi-Fi name',
    'Wi-Fi password': 'Wi-Fi password',
    'Generate QR-code': 'Generate QR-code',
    'QR-code': 'QR-code',
    ID: 'ID',
    'Fiscal Online Registrars': 'Fiscal Online Registrars',
    'Scanning Devices': 'Scanning Devices',
    'Registrar Connected To Sales': 'Registrar Connected To Sales',
    'Registrar NOT Connected To Sales': 'Registrar NOT Connected To Sales',
    Enable: 'Enable',
    Disable: 'Disable',
    'VAT Enabled': 'VAT Enabled',
    'VAT Disabled': 'VAT Disabled',
    Connect: 'Connect',
    Disconnect: 'Disconnect',
    'Generate X Report': 'Generate X-Report',
    'Open Shift': 'Open Shift',
    'Close Shift': 'Close Shift(Create Z-Report)',
    'Activate promotion alert':
      'After activating the Promotion, mobile application users will receive a push notification.',
    'Enter each new value on a new line': 'Enter each new value on a new line',
    'Required custom field value':
      'To make the field optional, leave the first line empty.',
    Delete: 'Delete',
    Edit: 'Edit',
    Lock: 'Lock',
    Unlock: 'Unlock',
    Archive: 'Archive',
    Restore: 'Restore',
    Archived: 'Archived',
    'Are you sure you want to delete': 'Are you sure you want to delete',
    'with ID': 'with ID',
    'Online Certificates': 'Online Certificates',
    'Create Online Certificate': 'Create Online Certificate',
    'New Online Certificate': 'New Online Certificate',
    'Edit Online Certificate': 'Edit Online Certificate',
    'Update Online Certificate': 'Update Online Certificate',
    Position: 'Position',
    'Total Price': 'Total Price',
    'Order_position has already been taken':
      'Order_position has already been taken',
    'Online Payment Key': 'Online Payment Key {{key_type}}',
    'Online Payment Keys': 'Online Payment Keys',
    '— None —': '— None —',
    'Edit {{title}}': 'Edit {{title}}',
    'New {{title}}': 'New {{title}}',
    'Find Client by ID': 'Find Client by ID',
    Submit: 'Submit',
    'Your Cart': 'Your Cart',
    'Available Services': 'Available Services',
    'Select services and payment methods to create a new order.':
      'Select services and payment types to create a new order.',
    'Your Cart is empty': 'Your Cart is empty',
    'Select Services': 'Select Services',
    'Select Service': 'Select Service',
    Search: 'Search',
    'Search services...': 'Search services...',
    'Payment Key Required': 'Payment Key Required',
    'Service cannot be created without at least one active Online Payment Key.':
      'Service cannot be created without at least one active Online Payment Key.',
    'Go to Payment Keys': 'Go to Payment Keys',
    Theme: 'Theme',
    'Light theme': 'Light',
    'Dark theme': 'Dark',
    Staff: 'Staff',
    Settings: 'Settings',
  },
  uk: {
    Create: 'Створити',
    Update: 'Оновити',
    Save: 'Зберегти',
    Close: 'Закрити',
    'Are you sure?': 'Ви впевнені?',
    'Scroll down': 'Прокрутити вниз',
    'Scroll up': 'Прокрутити вгору',
    Actions: 'Дії',
    'Rows Per Page': 'Рядків на сторінці',
    Of: 'з',
    Previous: 'Назад',
    Next: 'Вперед',
    "Can't be blank": 'Поле не може бути порожнім',
    Yes: 'Так',
    No: 'Ні',
    'No Info': 'Не Вказано',
    'Additional Filters': 'Додаткові фільтри',
    Filter: 'Фільтрувати',
    'Filters have been changed but not applied':
      'Фільтри змінено, але не застосовано',
    'Loading...': 'Завантаження...',
    'Nothing Found': 'Нічого Не Знайдено',
    'No Data Provided': 'Дані відсутні',
    'No options available': 'Немає доступних варіантів',
    Cash: 'Готівка',
    cash: 'Готівка',
    Card: 'Картка',
    Terminal: 'Термінал',
    'Send to Terminal': 'На термінал',
    'Terminal Payment': 'Оплата на терміналі',
    'Waiting for terminal...': 'Очікування терміналу...',
    'Sending to terminal': 'Відправлення на термінал',
    'Terminal accepted request': 'Термінал знайдено',
    'Amount accepted by terminal': 'Сума відображена на терміналі',
    'Payment successful': 'Оплата пройшла успішно',
    'Payment declined': 'Оплату відхилено',
    'Waiting for payment': 'Очікуємо оплату',
    'Terminal not found': 'Термінал не знайдено',
    'Terminal connection lost': 'Зʼєднання з терміналом втрачено',
    'Failed to send to terminal': 'Не вдалося відправити на термінал',
    Online: 'Онлайн',
    'Transfer to card': 'Переказ на картку',
    Deposit: 'Депозит',
    'Export CSV': 'Експорт CSV',
    'No services selected': 'Немає вибраних сервісів',
    From: 'Починаючи з',
    Till: 'До (Не Включно)',
    Confirmation: 'Підтвердження',
    Confirm: 'Підтвердити',
    'Select File': 'Виберіть Файл',
    'Choose File': 'Вибрати файл',
    'Remove File': 'Видалити файл',
    'Are You Sure?': 'Ви впевнені?',
    'Selected services': 'Вибрані сервіси',
    'Show Hidden Services': 'Показати невидимі сервіси',
    'Select services': 'Вибрати сервіси',
    'Choose services for the certificate': 'Виберіть сервіси для сертифікату',
    'Choose services for the online service':
      'Виберіть сервіси для онлайн сервісу',
    Select: 'Вибрати',
    Analytics: 'Аналітика',
    'Edit Company': 'Редагування Компанії',
    'Booking Analytics': 'Букінг Аналітика',
    'Active Purchased Services By Date': 'Активні куплені сервіси по даті',
    Price: 'Ціна',
    Service: 'Сервіс',
    Discount: 'Знижка',
    Active: 'Активний',
    UAH: 'грн.',
    fileWeightMsg: 'Розмір файлу не повинен перевищувати {{size}} МБ',
    'Paid Bookings By Booking Dates': 'Сплачені бронювання по датах бронювання',
    'Paid Bookings By Payment Dates': 'Сплачені бронювання по датах платежів',
    Date: 'Дата',
    Count: 'Кількість',
    Responses: 'Відповіді',
    'Select Location': 'Виберіть Локацію',
    'Distributed money': 'Розподілені кошти',
    'Money is distributed incorrectly': 'Кошти розподілені неправильно',
    'Select payment type': 'Оберіть тип оплати',
    ', left': ', залишилось',
    'Select a payment card': 'Оберіть платіжну картку',
    'Not enough deposit': 'Недостатньо коштів на депозиті',
    'To basic payment types': 'До основних типів оплати',
    Total: 'Разом',
    'Income Sources': 'Типи оплати',
    ufo_tooltip:
      'Unrecognized for online (UFO)\nПокупка сервісу онлайн, який можна\nвикористовувати на кількох локаціях',
    'Client deposit': 'Депозит клієнта',
    'Deposit movements': 'Рух депозитних коштів',
    'History of client deposit changes': 'Історія змін депозиту клієнта',
    'Cancel order': 'Скасувати замовлення',
    'Cancel online order': 'Скасувати онлайн замовлення',
    'Cancel order to deposit': 'Скасувати замовлення до депозиту',
    'Cancel service usage': 'Скасувати використання сервісу',
    'Created At': 'Створено',
    Amount: 'Сума',
    in: 'Зарахування',
    out: 'Списання',
    'to deposit': 'На депозит',
    'to client': 'До клієнта',
    'Order ID': 'ID замовлення',
    'Order type': 'Тип замовлення',
    'Orders Info': 'Інформація щодо замовлень',
    'Payment type': 'Тип оплати',
    Fiscalized: 'Фіскалізовано',
    'Purchased Service Id': 'Id сервісу',
    User: 'Користувач',
    Client: 'Клієнт',
    Time: 'Час',
    'Action Type': 'Тип дії',
    'Service Usage History Id': 'Id історії використання сервісу',
    'Payment Id': 'Id платежу',
    'User Activity Logs': 'Логи активності користувачів',
    Locations: 'Локації',
    'Service Usage History': 'Історія використання сервісів',
    'Use Time': 'Час використання',
    'Service Id': 'Id сервісу',
    Trainer: 'Тренер',
    'Certificate Code': 'Код сертифікату',
    'Final Price': 'Сума замовлення',
    'Price per payment type': 'Поділ за типом оплати',
    Cancel: 'Скасувати',
    'Send back to': 'Повернуто',
    'Purchase of a certificate': 'Придбання сертифікату',
    'Purchase from the administrator': 'Придбано адміністратором',
    'Online booking': 'Онлайн бронювання',
    Name: 'Назва',
    'Display name': 'Назва для клієнта',
    'System Owners': 'Системні Власники',
    Description: 'Опис',
    Image: 'Зображення',
    'Choose Image File': 'Вибрати зображення',
    'New Promotion': 'Нова Промоакція',
    'Create Promotion': 'Створити промоакцію',
    Promotions: 'Промоакції',
    'Edit Promotion': 'Редагування Промоакції',
    'Update Promotion': 'Оновити Промоакцію',
    'Connect scanning device form': 'Форма підключення сканера',
    'Wi-Fi name': 'Назва Wi-Fi мережі',
    'Wi-Fi password': 'Пароль Wi-Fi мережі',
    'Generate QR-code': 'Сгенерувати QR-код',
    'QR-code': 'QR-код',
    ID: 'Ідентифікатор',
    'Fiscal Online Registrars': 'Фіскальні Онлайн Реєстратори',
    'Scanning Devices': 'Скануючі пристрої',
    'Registrar Connected To Sales': 'Реєстратор підключений до продажів',
    'Registrar NOT Connected To Sales': 'Реєстратор НЕ підключений до продажів',
    Enable: 'Увімкнути',
    Disable: 'Вимкнути',
    'VAT Enabled': 'ПДВ Увімкнено',
    'VAT Disabled': 'ПДВ Вимкнено',
    Connect: 'Підключити',
    Disconnect: 'Відключити',
    'Generate X Report': 'Сформувати X-Звіт',
    'Open Shift': 'Відкрити зміну',
    'Close Shift': 'Закрити зміну(Сформувати Z-Звіт)',
    'Activate promotion alert':
      'Після активації Промоакції, користувачі мобільного застосунку отримають push-повідомлення.',
    'Enter each new value on a new line':
      'Введіть кожне нове значення з нового рядка',
    'Required custom field value':
      'Щоб зробити поле не обовʼязковим, залиште перший рядок пустим.',
    Delete: 'Видалити',
    Edit: 'Редагувати',
    Lock: 'Заблокувати',
    Unlock: 'Розблокувати',
    Archive: 'Архівувати',
    Restore: 'Відновити',
    Archived: 'Архівовано',
    'Are you sure you want to delete': 'Ви впевнені, що хочете видалити',
    'with ID': 'з ID',
    'Online Certificates': 'Онлайн Сертифікати',
    'Create Online Certificate': 'Створити Онлайн Сертифікат',
    'New Online Certificate': 'Новий Онлайн Сертифікат',
    'Edit Online Certificate': 'Редагування Онлайн Сертифікату',
    'Update Online Certificate': 'Оновити Онлайн Сертифікат',
    Position: 'Позиція',
    'Total Price': 'Загальна сума',
    'Order_position has already been taken': 'Позиція вже зайнята',
    'Online Payment Key': 'Платіжний ключ {{key_type}}',
    'Online Payment Keys': 'Платіжні ключі',
    '— None —': '— Не обрано —',
    'Edit {{title}}': 'Редагування {{title}}',
    'New {{title}}': 'Новий {{title}}',
    'Find Client by ID': 'Знайти клієнта за ID',
    Submit: 'Підтвердити',
    'Your Cart': 'Ваш Кошик',
    'Available Services': 'Доступні Сервіси',
    'Select services and payment types to create a new order.':
      'Виберіть сервіси та типи оплати для створення нового замовлення.',
    'Your Cart is empty': 'Ваш Кошик порожній',
    'Select Services': 'Вибрати сервіси',
    'Select Service': 'Вибрати сервіс',
    Search: 'Пошук',
    'Search services...': 'Шукати сервіси...',
    'Payment Key Required': 'Потрібен платіжний ключ',
    'Service cannot be created without at least one active Online Payment Key.':
      'Сервіс не може бути створений без хоча б одного активного платіжного ключа.',
    'Go to Payment Keys': 'Перейти до платіжних ключів',
    Theme: 'Тема',
    'Light theme': 'Світла',
    'Dark theme': 'Темна',
    Staff: 'Працівники',
    Settings: 'Налаштування',
  },
};
